(function ($) {
	// Open cart after add-to-cart
	$(document).gp_ready(function () {
		$('[data-form-id="product-detail-add-to-cart"]').gp_on('ajax_done', function (e, form_id) {
			$(document).trigger('open_modal', ['cart'])
		})
	})
})(jQuery);